<template>
    <div class="container-fluid">
        <div class="text-right btngroup">
            <CButton
                    class="addBtn"
                    @click="createRecord"
            >
                Create
            </CButton>
        </div>
      <search-items v-model="searchFile" :searchHandler="searchFiles" v-if="searchtab"></search-items>
      <search-items v-model="searchUser" :searchHandler="searchUserFiles" v-if="!searchtab"></search-items>
        <div>
            <b-tabs  content-class="mt-3">
                <b-tab @click="switchSearch('file')"  title="Files" id="files" :active="searchtab">
                    <b-table striped responsive="sm" show-empty
                             id="my-table"
                             :items="datasource"
                             :fields="headers"
                    >
                        <template #cell(actions)="item">
                            <download class="download_file ml-2" fillColor="#009FE3" @click="DownloadFile(item.item)" />
                            <see v-if="item.item.file_type=='color'" class="delete_file ml-2" @click="viewColor(item.item.json_data, item.item.id)" fillColor="#009FE3" />
                            <see v-if="item.item.file_type=='sizes'" class="delete_file ml-2" @click="viewSize(item.item.json_data, item.item.id)" fillColor="#009FE3" />
                        </template>
                    </b-table>
                    <b-pagination
                            v-model="filePagination.currentPage"
                            :total-rows="filePagination.rows"
                            :per-page="filePagination.perPage"
                            aria-controls="itemList"
                            align="center"
                            @change="handleFiles"
                            v-if="filePagination.total > 0"
                            :key="filePagination.currentPage"
                    ></b-pagination>
                </b-tab>
                <b-tab @click="switchSearch('user')" id="users" title="User Uploads" :active="!searchtab">
                    <b-table  striped responsive="sm" show-empty
                             id="my-table"
                             :items="userdatasource"
                             :fields="headers"
                    >
                        <template #cell(actions)="item">
                            <download class="download_file ml-2" fillColor="#009FE3" @click="DownloadFile(item.item)" />
                            <see v-if="item.item.file_type=='color'" class="delete_file ml-2" @click="viewColor(item.item.json_data, item.item.id)" fillColor="#009FE3" />
                            <see v-if="item.item.file_type=='sizes'" class="delete_file ml-2" @click="viewSize(item.item.json_data, item.item.id)" fillColor="#009FE3" />
                        </template>
                    </b-table>
                    <b-pagination
                            v-model="userPagination.currentPage"
                            :total-rows="userPagination.rows"
                            :per-page="userPagination.perPage"
                            aria-controls="itemList"
                            align="center"
                            @change="handleUserFiles"
                            v-if="userPagination.total > 0"
                            :key="userPagination.currentPage"
                    ></b-pagination>
                </b-tab>
            </b-tabs>
        </div>
        <b-modal id="datasourceModel" size="md" no-close-on-backdrop hide-footer>
            <template #modal-title>
                <span>Create Data Source</span>
            </template>
            <b-form-group label="Data source type" label-for="input-2">
              <template v-if="role_name != 'superadmin'">
                <v-select
                    v-model="selected_factory"
                    :options="user_factory_options"
                    :name="`user_factory`"
                    placeholder="Select Factory"
                    v-validate="{required: true}"
                >
                </v-select>
                <div v-if="errors && errors.first('user_factory')" class="error_msg">
                  Factory is required
                </div>
              </template>

                <v-select :options="fileTypes" v-validate="{required: true}" v-model="file_type" name="source_type" @input="setFileType"></v-select>
                <div v-if="errors && errors.first('source_type')" class="error_msg">
                    Data source type is required
                </div>
            </b-form-group>

            <div id="apps" @dragover.prevent @drop.prevent>
            <div class="container" @click="handleFileInput" v-if="file_type"  @dragleave="fileDragOut" @dragover="fileDragIn" @drop="handleFileDrop"  v-bind:style="{ 'background-color': color }">
                <b-form-group >
                    <b-form-file class="file-wrapper"
                                 ref="file-input"
                            v-model="name"
                            :accept="form.type"
                            name="datasource"
                            v-validate="{required: true}"
                            :state="Boolean(form.file)"
                            placeholder="click or drag to insert"
                            @change="ResetOverride" style="text-align: center;width: 300px;height: 5em;vertical-align: middle;display: none;position: relative;overflow:hidden;
  background: grey;"></b-form-file> <p v-if="name" style="text-align: center; margin-top: 30px" >{{name.name}}</p>
                    <div v-if="errors && errors.first('datasource')" class="error_msg">
                        Data source file is required
                    </div>
                </b-form-group>
            </div>
            </div>


            <hr>
            <div class="text-right mt-2">
                <b-button variant="primary" class="mr-3" @click="addDataSource(false)">Save</b-button>
                <b-button v-if="form.override" variant="success" @click="addDataSource(true)">Override File</b-button>
            </div>
        </b-modal>

        <!-- color source view/edit modal -->
        <b-modal id="colorSource" size="lg" no-close-on-backdrop hide-footer>
            <b-alert v-for="(err, index) in error" variant="danger" :key="index" show>
                {{err}}
            </b-alert>
            <CDataTable
            :items="colors"
            :fields="colorsHeader"
            hover
            sorter
            >
                <template #name="{item}">
                    <td>
                        <input type="text" v-model="item.name">
                    </td>
                </template>
                <template #value="{item}">
                    <td>
                        <input type="color" v-model="item.value">
                    </td>
                </template>
                <template #position="{item}">
                    <td>
                        <input type="number" v-model="item.position">
                    </td>
                </template>
                <template #action="{item, index}">
                    <td>
                        <delete class="delete_file ml-2" @click="deleteColor(index)" fillColor="#E30000" />
                    </td>
                </template>
            </CDataTable>
            <hr>
            <div class="text-right">
                <plus class="addColor mr-2" @click="AddNewColor" title="add new color" :size=Number(40) fillColor="#07880f" />
                <b-button variant="primary" @click="SaveColors">Save Colors</b-button>
            </div>
        </b-modal>

      <!-- Size source view/edit modal -->
      <b-modal id="sizeSource" size="lg" no-close-on-backdrop hide-footer>
        <b-alert v-for="(err, index) in error" variant="danger" :key="index" show>
          {{err}}
        </b-alert>
        <CDataTable
            :items="sizes"
            :fields="sizesHeader"
            hover
            sorter
        >
          <template #name="{item}">
            <td>
              <input type="text" v-model="item.name">
            </td>
          </template>
          <template #action="{item, index}">
            <td>
              <delete class="delete_file ml-2" @click="deleteSize(index)" fillColor="#E30000" />
            </td>
          </template>
        </CDataTable>
        <hr>
        <div class="text-right">
          <plus class="addColor mr-2" @click="AddNewSize" title="add new color" :size=Number(40) fillColor="#07880f" />
          <b-button variant="primary" @click="SaveSizes">Save Sizes</b-button>
        </div>
      </b-modal>
    </div>
</template>
<script>
import Delete from 'vue-material-design-icons/Delete.vue';
import Download from 'vue-material-design-icons/Download';
import See from 'vue-material-design-icons/Eye';
import Plus from 'vue-material-design-icons/PlusCircleOutline';
import SearchItems from '@/components/SearchItems.vue';
import {getLastPage, getPageModal, removePageModal, setPageModal} from "@/helpers/Helpers";
export default {
    components:{
        Delete,
        SearchItems,
        Download,
        See,
        Plus,
    },
    data () {
        return {
            searchFile:'',
            searchUser:'',
            filePagination:{
              rows:null,
              currentPage:null,
              perPage:null,
              total:0
            },
            userPagination:{
              rows:null,
              currentPage:null,
              perPage:null,
              total:0
            },
            color: '#99ccff',
            datasource: [],
            searchtab:true,
            userdatasource:[],
            headers:[
                {key:'file_name', label:'Filename'},
                {key:'file_size', label:'Filesize'},
                {key:'updated_at', label:'Date upload'},
                {key:'actions', label:'Actions'},
            ],
            colorsHeader: [
                {key: 'name'},
                {key: 'value', label: 'Color'},
                {key: 'position',},
                {key: 'action', sorter: false},
            ],
          sizesHeader: [
            {key: 'name'},
            {key: 'action', sorter: false},
          ],
            fileTypes: [
                {id: 'base_model', label: 'Model'},
                {id: 'color', label: 'Colors'},
                {id: 'font', label: 'Fonts'},
                {id: 'sizes', label: 'Sizes'},
                {id: '3d_model', label: '3D Model'},
                {id: '3d_texture', label: '3D Texture'},
                {id: 'product_pattern', label: 'Product Pattern'},
            ],
            form:{
                file: null,
                file_type: '',
                type: null,
                width: null,
                height: null,
                override: false,
            },
            file_type: '',
            checkbox: [],
            file_url: process.env.VUE_APP_FILE_URL,
            colors: '',
            sizes:'',
            error: [],
            name:[],
            size_id:'',
            storage_url: process.env.VUE_APP_FILE_URL,
            user_factory_options:[],
            selected_factory:null
        }
    },
    async created(){
      await this.$store.dispatch('getUserFactories');
      let user_factories = this.$store.getters.userFactoriesOptions;
      if(user_factories.length > 0) {
        this.user_factory_options = user_factories;
        this.selected_factory = user_factories[0];
      }
      this.$store.commit('set', ['showLoader', true]);
      let payload = '?page=&name=&';
      let product_modal = getPageModal();
      if(product_modal && product_modal.page && product_modal.page_name === this.$route.name){
        if(product_modal.search){
          payload = `?page=${1}&name=&`;
        }
        else{
          payload = `?page=${product_modal.page}&name=&`;
        }
        if(product_modal.tab == 'user'){
          this.searchtab = false
          this.searchUser = ""
        }
        else{
          this.searchtab = true
          this.searchFile = ""
        }
        let res = await this.$store.dispatch("getFiles", payload);
        let data = await this.$store.dispatch("getUserFile", payload);
        this.filePagination = this.makeFilesPagination(res.data);
        this.userPagination = this.makeUserPagination(data.data);
        this.datasource = this.$store.getters.getFiles;
        this.userdatasource = this.$store.getters.getUserFiles;
        this.$store.commit('set', ['showLoader', false]);
      }
      else{
        removePageModal()
        let res = await this.$store.dispatch("getFiles", payload);
        let data = await this.$store.dispatch("getUserFile", payload);
        this.filePagination = this.makeFilesPagination(res.data);
        this.userPagination = this.makeUserPagination(data.data);
        this.datasource = this.$store.getters.getFiles;
        this.userdatasource = this.$store.getters.getUserFiles;
        this.$store.commit('set', ['showLoader', false]);
      }
    },
    methods: {
        async getFiles(payload){
          let res = await this.$store.dispatch("getFiles", payload);
          this.filePagination = this.makeFilesPagination(res.data);
        },
        async getUserFiles(payload){
          let data = await this.$store.dispatch("getUserFile", payload);
          this.userPagination = this.makeUserPagination(data.data);
        },
        makeFilesPagination(data){
            this.filePagination.currentPage = data.current_page;
            this.filePagination.rows = data.total;
            this.filePagination.perPage = data.per_page;
            this.filePagination.total = data.total;
            return this.filePagination;
        },
        makeUserPagination(data){
            this.userPagination.currentPage = data.current_page;
            this.userPagination.rows = data.total;
            this.userPagination.perPage = data.per_page;
            this.userPagination.total = data.total;
            return this.userPagination;
        },
        switchSearch(tab){
            if (tab == 'user'){
                this.searchtab = false;
                setPageModal(1,this.$route.name,this.searchUser,'user');
                this.searchUserFiles();
            }
            if (tab == 'file'){
                this.searchtab =true;
                setPageModal(1,this.$route.name,this.searchFile,'file');
                this.searchFiles();
            }
         },
        async deleteFile(id){
            try{
                this.$store.commit('set', ['showLoader', true]);
                await this.$store.dispatch('deleteFiles', [id]);
                this.$store.commit('set', ['showLoader', false]);
            }catch(err){
                this.showError(err);
                this.$store.commit('set', ['showLoader', false]);
            }
        },
        handleFileDrop(e) {
            this.name = e.dataTransfer.files[0];
            this.color="#99ccff"
        },
        handleFileInput() {
            this.$refs['file-input'].$el.childNodes[0].click();
        },
        fileDragIn(){
            this.color="white"
        },
        fileDragOut(){
            this.color = "#99ccff"
        },
        deleteRecords(){
            console.log('delete record');
        },
       async handleFiles(page=''){
            let params = '?page='+page+'&name='+this.searchFile;
            setPageModal(page,this.$route.name,this.searchFile,'file');
            let res = await this.$store.dispatch('getFiles', params);
            this.filePagination = this.makeFilesPagination(res.data);
            this.datasource = this.$store.getters.getFiles;
       },
        async handleUserFiles(page=''){
         let params = '?page='+page+'&name='+this.searchUser;
         setPageModal(page,this.$route.name,this.searchUser,'user');
         let res = await this.$store.dispatch('getUserFile', params);
          this.userPagination = this.makeUserPagination(res.data);
         this.userdatasource = this.$store.getters.getUserFiles;
        },
        async searchFiles(){
            let params = '?name='+this.searchFile;
            setPageModal(1,this.$route.name,this.searchFile,'file');
            let res = await this.$store.dispatch('getFiles', params);
            this.filePagination = this.makeFilesPagination(res.data);
            this.datasource = this.$store.getters.getFiles;
        },
        async searchUserFiles(){
            let params = '?name='+this.searchUser;
            setPageModal(1,this.$route.name,this.searchUser,'user');
            let res = await this.$store.dispatch('getUserFile', params);
            this.makeUserPagination(res.data);
            this.userdatasource = this.$store.getters.getUserFiles;

        },
        createRecord(){
            this.form.name = '';
            this.form.file = null;
            this.form.file_type = '';
            this.form.type = null;
            this.form.width = null;
            this.form.height = null;
            this.form.override = false;
            this.file_type = '';
            this.selected_factory = '';
            this.$bvModal.show("datasourceModel");
        },
        async addDataSource(override = false){
            let valid = await this.$validator.validate();

            if(valid){
                let formData = new FormData();
                formData.append('file', this.name);
                formData.append('file_type', this.file_type.id);
                formData.append('override', override);
                formData.append('name', this.name.name);
                formData.append('width', 200);
                formData.append('height', 200);
                if(this.role_name == "factory") {
                  formData.append('factory_id', this.selected_factory.value);
                }
                if (this.searchtab){
                  setPageModal(this.filePagination.currentPage,this.$route.name,this.searchFile,'file');
                }
                else{
                  setPageModal(this.userPagination.currentPage,this.$route.name,this.searchUser,'user');
                }
                try{
                    this.$store.commit('set', ['showLoader', true]);
                    let res = await this.$store.dispatch("addDataSource", formData);
                    this.$emit("dataSourceAdded", res);
                    this.datasource = this.$store.getters.getFiles;
                    this.userdatasource = this.$store.getters.getUserFiles;
                    this.filePagination.rows =this.filePagination.rows + 1;
                    const product_modal = getPageModal();
                    if(product_modal && product_modal.page && product_modal.page_name === this.$route.name && override == false) {
                        if (product_modal.tab == 'user') {
                          this.searchtab = false
                          this.searchUser = ""
                          this.nextPageOnCreation('page','name', this.userdatasource.length, this.userPagination.perPage, this.userPagination.currentPage, getLastPage(this.userPagination.perPage ,this.userPagination.total ), this.$route.name, this.getUserFiles);
                        } else {
                          this.searchtab = true
                          this.searchFile = ""
                          this.nextPageOnCreation('page','name', this.datasource.length, this.filePagination.perPage, this.filePagination.currentPage, getLastPage(this.filePagination.perPage ,this.filePagination.total ), this.$route.name, this.getFiles);
                        }
                      }
                      else{
                        this.searchtab = true
                        this.searchFile = ""
                        this.nextPageOnCreation('page','name', this.datasource.length, this.filePagination.perPage, this.filePagination.currentPage, getLastPage(this.filePagination.perPage ,this.filePagination.total ), this.$route.name, this.getFiles);
                      }
                    this.name = [];
                   this.$bvModal.hide("datasourceModel");
                    this.$store.commit('set', ['showLoader', false]);
                   this.showToast(res.message, 'SUCCESS');
                }catch(err){
                    this.showError(err);
                    this.$store.commit('set', ['showLoader', false]);
                    this.form.override =  err.response.data.override;
                }
            }
        },
        setFileType(){

            let file_type = this.file_type;
            if (file_type == null || file_type == ''){
               this.name = [];
            }
            if(file_type){
                if(file_type.id == 'base_model'){
                  this.form.type = '.jpg, .png';
                }else if(file_type.id == 'texture' || file_type.id == 'logo'){
                  this.form.type = '.svg';
                }else if(file_type.id == 'color' || file_type.id == 'sizes'){
                  this.form.type = '.csv';
                }else if(file_type.id == 'font' || file_type.id == 'product_pattern'){
                  this.form.type = '.zip';
                }
            }
        },
        ResetOverride(){
            this.form.override = false;
        },
        DownloadFile(item){
            this.$store.dispatch('downloadFile', item);
        },
        viewColor(colors, id){
            this.colors = colors;
            this.id = id;
            this.error = [];
            this.$bvModal.show('colorSource');
        },
      viewSize(sizes, id){
        this.sizes = sizes;
        this.size_id = id;
        this.error = [];
        this.$bvModal.show('sizeSource');
      },
        async SaveColors(){
            this.error = [];
            let rowNum = 1;
            this.colors.forEach((element, index) => {
                rowNum = ++index;
                if(element.name == '' || element.position == '' || element.value == ''){
                    this.error.push('Data of row '+rowNum+' is invalid, please write name, select color and add positon');
                }
            });
            if(this.error.length == 0){
                let data = {
                    'color_text': JSON.stringify(this.colors),
                    'id': this.id,
                }
                try{
                    this.$store.commit('set', ['showLoader', true]);
                    await this.$store.dispatch('updateColor', data);
                    this.datasource = this.$store.getters.getFiles;
                    this.$bvModal.hide('colorSource');
                    this.$store.commit('set', ['showLoader', false]);
                }catch(err){
                    this.$bvModal.hide('colorSource');
                    this.showError(err);
                    this.$store.commit('set', ['showLoader', true]);
                }
            }
        },
      async SaveSizes(){
        this.error = [];
        let rowNum = 1;
        this.sizes.forEach((element, index) => {
          rowNum = ++index;
          if(element.name == ''){
            this.error.push('Data of row '+rowNum+' is invalid, please write name');
          }
        });
        if(this.error.length == 0){
          let data = {
            'size_text': JSON.stringify(this.sizes),
            'id': this.size_id,
          }
          try{
            this.$store.commit('set', ['showLoader', true]);
            await this.$store.dispatch('updateSizes', data);
            this.datasource = this.$store.getters.getFiles;
            this.$bvModal.hide('sizeSource');
            this.$store.commit('set', ['showLoader', false]);
          }catch(err){
            this.$bvModal.hide('sizeSource');
            this.showError(err);
            this.$store.commit('set', ['showLoader', true]);
          }
        }
      },
        deleteColor(index){
            this.colors =  this.colors.flatMap((e, i) => {
                if(i != index)
                    return e;
                else
                    return [];
            });
        },
      deleteSize(index){
        this.sizes =  this.sizes.flatMap((e, i) => {
          if(i != index)
            return e;
          else
            return [];
        });
      },
        AddNewColor(){
            this.colors.push({
                name: '',
                value: '',
                position: '',
            });
        },
      AddNewSize(){
        this.sizes.push({
          name: '',
        });
      },
        async myFunction(currentPage){
            try{
                this.current_page = currentPage;
                let params = '?name='+this.search+'&page='+currentPage;
                this.$store.commit('set', ['showLoader', true]);
                await this.$store.dispatch('factories', params);
                this.$store.commit('set', ['showLoader', false]);
                this.skus = this.$store.getters.getSku;
                this.pages = this.$store.getters.totalPages;
            }catch(err){
                this.$store.commit('set', ['showLoader', false]);
                console.log("Error: ", err.response.data.errors);
            }
        }
    },

}
</script>
<style scoped type="scss">
    .download_file, .delete_file, .addColor{
        cursor: pointer;
    }
    .nav-tabs{
        border: none;
    }
    .file-wrapper {
        text-align: center;
        width: 300px;
        height: 5em;
        vertical-align: middle;
        display: table-cell;
        position: relative;
        overflow: hidden;
        background: gray; /* and other things to make it pretty */
    }
    .container{
        border: 2px dashed pink;
        min-height: 150px;
    }
    .apps{
        border: 1px solid yellow;
        height: 100vh;
    }
</style>